import React from "react"
import Icon from "@kit/design/icon"
import Input from "@kit/design/input"

export function CustomInput({
  label,
  icon,
  type = "number",
  value,
  onChange
}) {
  function handleChange(e) {
    const value = e.target.value

    if (isNaN(value)) {
      onChange(0)
      return
    }

    const numericalValue = Number(e.target.value)
    if (numericalValue > 1000) return
    onChange(numericalValue)
  }

  return (
    <div className="relative">
      <Input
        prepend={
          icon ? (
            <span title={label}>
              <Icon name={icon} />
            </span>
          ) : (
            label
          )
        }
        placeholder="40"
        type={type}
        value={value}
        min={type === "number" ? 0 : null}
        onChange={handleChange}
        append="px"
      />
    </div>
  )
}
